<h1>{{ 'prepaid_codes_header' | translate }}</h1>

<form [formGroup]="addPrepaidForm" (ngSubmit)="submitPrepaidForm()" style="margin-bottom: 30px;">
  <div class="p-grid marginzero p-justify-between">
    <div class="p-col-12 p-sm-4 p-md-3">
      <div style="display: flex; align-items: center;">
        <input formControlName="value" placeholder="{{ 'prepaid_value' | translate }}" type="text" pInputText style="width:100%" />
        <div style="margin-left: 5px;">{{ currencySymbol }}</div>
      </div>
    </div>
    <div class="p-col-12 p-sm-4 p-md-3">
      <input formControlName="expired_date" type="date" pInputText style="width:100%" />
    </div>
    <div class="p-col-12 p-sm-4 p-md-3">
      <input formControlName="codes_amount" placeholder="{{ 'codes_amount' | translate }}" type="number" pInputText min="0" style="width:100%" />
    </div>
    <div class="p-col-12 p-sm-4 p-md-3">
      <app-primary-button type="submit" label="{{ 'prepaid_add' | translate }}" [disabled]="addPrepaidForm.invalid"></app-primary-button>
    </div>
  </div>
</form>

<p-table
  [value]="prepaidCodes"
  [loading]="listLoading"
  styleClass="ui-table">
  <ng-template pTemplate="caption">
      <span style="border-bottom: 3px solid #40499b; padding-bottom: 5px;">{{ 'prepaid_codes_list' | translate }}</span>
  </ng-template>
  <ng-template pTemplate="header">
    <tr class="table-header">
      <th>{{ 'code' | translate }}</th>
      <th>{{ 'prepaid_value' | translate }}</th>
      <th>{{ 'prepaid_expired_date' | translate }}</th>
      <th>{{ 'prepaid_activation_date' | translate }}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-code>
    <tr>
      <td>{{code.code}}</td>
      <td>{{code.value | currencyReduce: true | currency:code.value:'zł'}}</td>
      <td>{{code.expired_date}}</td>
      <td>{{code.activated_date}}</td>
    </tr>
  </ng-template>
</p-table>
